// extracted by mini-css-extract-plugin
module.exports = {"container":"coupon_container__aQpZy","content":"coupon_content__EPsei","image":"coupon_image__T23Cz","title":"coupon_title__gIvQS","text":"coupon_text__Gmtng"};